<template>
  <VLayout :title="$t('legal.title')">
    <VMarkdownView :mdtext="$t('legal.legal_text')" />
  </VLayout>
</template>

<script>
import VLayout from "@/layouts/Default";
import VMarkdownView from "@/components/VMarkdownView";

export default {
  components: {
    VLayout,
    VMarkdownView,
  },
  fallbackI18n: {
    messages: {
      und: {
        legal: {
          title: "Legal notice",
          legal_text: "",
        },
      },
    },
  },
  mounted: function() {
    this.putBreadCrumb();
  },
  methods: {
    putBreadCrumb() {
      this.$store.commit("siteconf/MUTATE_BREADCRUMB", [
        {
          langkey: "breadcrumb.home",
          to: { name: "home" },
        },
        {
          langkey: "legal.title",
          to: { name: "legal" },
        },
      ]);
    },
  },
};
</script>

<style>
</style>
